import { render } from "./DoctorRank.vue?vue&type=template&id=5c6baa44&scoped=true"
import script from "./DoctorRank.vue?vue&type=script&lang=js"
export * from "./DoctorRank.vue?vue&type=script&lang=js"

import "./DoctorRank.vue?vue&type=style&index=0&id=5c6baa44&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c6baa44"

export default script